// @flow
import React, { createContext, useReducer } from 'react';

const INITIAL_STATE = {
  fromApp: false, // true if creator is opened from app (passes 'key' param)
  inWebView: false,
  realmUser: null,
  isPro: false,
  deepLinkURL: null,
};

export const SystemContext = createContext(INITIAL_STATE);

const Context = ({ children }) => {
  const reducer = (state, { type, data }) => {
    switch (type) {
      case 'SET_SYSTEM': {
        return {
          ...state,
          ...data,
        };
      }
      case 'CLEAR': {
        return INITIAL_STATE;
      }
      default: {
        return state;
      }
    }
  };

  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  return (
    <SystemContext.Provider value={{ state, dispatch }}>
      {children}
    </SystemContext.Provider>
  );
};

export default Context;
